import { ApiConfig } from '../config'

/**
 * 请求用户信息接口
 */
export async function fetchWebStatus(apiConfig: ApiConfig): Promise<{ status: number; data: any } | null> {
  try {
    const url = `${apiConfig.userApiBase}/users/~`
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    })

    const data = [204, 401].includes(response.status) ? null : await response.json()
    return {
      status: response.status,
      data,
    }
  } catch (error) {
    console.error('[OrayFastLoginSDK] fetchWebStatus network error:', error)
    return null
  }
}

/**
 * 授权登录接口
 */
export async function authorizeLoginApi(baseUrl: string, code: string): Promise<{ status: number; data: any } | null> {
  try {
    const url = `${baseUrl}/oauth2/authorize`
    const body = {
      type: 'authorization_code',
      authorization_code: {
        provider: 'oray',
        code,
      },
      is_set_session: true,
    }

    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })

    const data = await response.json()
    return {
      status: response.status,
      data,
    }
  } catch (error) {
    console.error('[OrayFastLoginSDK] authorizeLoginApi network error:', error)
    return null
  }
}
